export const QUERY_KEY = {
    GET_BASE_INFO: "GET_BASE_INFO",
    GET_STATUS: "GET_STATUS",
    GET_CHECK_DATE_ROOMS: "GET_CHECK_DATE_ROOMS",
    GET_RESERVE_INFO: "GET_RESERVE_INFO",
    GET_PAYMENT_ROOM_LIST: "GET_PAYMENT_ROOM_LIST",
    GET_GUIDE_INFO: "GET_GUIDE_INFO",
    GET_USE_ACCOUNT: "GET_USE_ACCOUNT",
    GET_BOOKING_CHECK: "GET_BOOKING_CHECK",
    GET_COUPON_LIST: "GET_COUPON_LIST",
};
